import React from 'react';

import './styles.scss';
import { useIntl } from 'react-intl';

const R14Details = () => {
  const intl = useIntl();
  return (
    <div>
      <div className="subtitle">
        {intl.formatMessage({
          id: 'r14.fixed',
          defaultMessage: 'Fixed rate overview',
        })}
      </div>

      <div className="text">
        <ul>
          <li>
            {intl.formatMessage({
              id: 'r14.fixedRateComparison',
              defaultMessage:
                'The Fixed rate is, on average, 4% higher than the Time-of-Day (5-8 p.m.) Rate.',
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: 'r14.priceBySeason',
              defaultMessage: 'The price for electricity is set by season.',
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: 'r14.sameRateAllDay',
              defaultMessage:
                'You pay the same electricity rate for all hours of the day.',
            })}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default R14Details;
